import { observable, action, runInAction } from "mobx";

import { DataLoadStatus, MentorProfile } from "../types";

class LandingStore {
  // Private instance
  private static _instance: LandingStore;
  
  @observable public loadStatus = DataLoadStatus.NOT_STARTED;
  @observable public mentorProfiles: MentorProfile[] = [];

  /**
   * Use LandingStore.instance to retrieve an instance of this class.
   */
  private constructor() {}

  /**
   * Instance of LandingStore.
   */
  public static get instance() {
    if (!this._instance) {
      this._instance = new LandingStore();
    }

    return this._instance;
  }

  @action
  public fetchMentors = async () => {
    this.loadStatus = DataLoadStatus.LOADING;
    
    // TODO This needs to be replaced with a request to backend
    const profiles = await Promise.resolve([
      {
        company: 'StarChain Ventures',
        firstName: 'Radhika',
        jobTitle: 'Founding Partner',
        lastName: 'Iyengar-Emens',
        profilePictureUrl: `/images/mentor-profiles/radhika-iyengar-emens.png`
      },
      {
        company: 'Google',
        firstName: 'Vicky',
        jobTitle: 'Engineering Manager',
        lastName: 'Xu',
        profilePictureUrl: '/images/mentor-profiles/vicky-xu.png'
      },
      {
        company: 'Walmart Labs',
        firstName: 'Laurent',
        jobTitle: 'VP of Engineering',
        lastName: 'Desegur',
        profilePictureUrl: '/images/mentor-profiles/laurent-desegur.png'
      },
      {
        company: 'LinkedIn',
        firstName: 'Maria',
        jobTitle: 'VP of Engineering',
        lastName: 'Zhang',
        profilePictureUrl: '/images/mentor-profiles/maria-zhang.png'
      },
      {
        company: 'BASE Communication',
        firstName: 'Janet',
        jobTitle: 'Owner',
        lastName: 'Vaewsorn',
        profilePictureUrl: '/images/mentor-profiles/janet-vaewsorn.png'
      },
      {
        company: 'Bamboo Myth',
        firstName: 'Jeanny',
        jobTitle: 'Founder',
        lastName: 'Chai',
        profilePictureUrl: '/images/mentor-profiles/jeanny-chai.png'
      },
      {
        company: 'Intuit',
        firstName: 'Katie',
        jobTitle: 'Staff Security Analyst',
        lastName: 'Greathouse',
        profilePictureUrl: '/images/mentor-profiles/katie-greathouse.png'
      },
      {
        company: 'Google',
        firstName: 'Grace',
        jobTitle: 'Product Manager',
        lastName: 'Chen',
        profilePictureUrl: '/images/mentor-profiles/grace-chen.png'
      },
      {
        company: 'Chevron',
        firstName: 'Ana',
        jobTitle: 'Senior Security Architect',
        lastName: 'Colocho',
        profilePictureUrl: '/images/mentor-profiles/ana-colocho.png'
      }
    ]);

    runInAction(() => {
      this.mentorProfiles = profiles;
      this.loadStatus = DataLoadStatus.LOADED;
    });
  }
}

export default LandingStore;
export const landingStore = LandingStore.instance;


// WEBPACK FOOTER //
// ./src/stores/LandingStore.ts